<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';
import debug from 'debug';
import Logger from '@/lib/logger';
import mockInit from '../mock.init';

const log = debug('vue:preQualify:template');

export default {
  name: 'preQualify-template',
  metaInfo: {
    title: 'Simulação',
  },
  methods: {
    ...mapActions('preQualify', [
      'setContext',
      'ready',
      'getLastState',
      'error',
      'init',
      'openModal',
    ]),
    errorHandler(error) {
      Logger.error(error);
      this.$router.replace({ name: 'checkout-error' });
      this.error(error);
    },
    async messageHandler(message) {
      const messageData = message.data;
      if (['init', 'openModal']
        .includes(messageData.ev)
        && this[messageData.ev]) {
        log(messageData.ev, messageData.data);
        try {
          await this[messageData.ev](messageData.data);
        } catch (error) {
          this.errorHandler(error);
        }
      } else if (messageData.ev) {
        log(`no handler on: ${messageData.ev}`);
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.messageHandler);
    if (this.$route.query.mock) {
      this.init(mockInit.data);
    } else {
      this.ready().catch(this.errorHandler);
    }
  },
  created() {
    this.setContext(this.$route.params.context).catch(this.errorHandler);
  },
};
</script>
